import {Outlet} from "react-router-dom";

function About() {
  return (
    <>
      <h4>About</h4>
      <Outlet />
    </>
  );
}
export default About;
